export default __webpack_public_path__ + "static/media/news76.7950634c.jpg";